import { Injectable } from '@angular/core';
import { IconSettingsService } from '@progress/kendo-angular-icons';

@Injectable()
export class TiIconSettingsService extends IconSettingsService {
  private iconDictionary: { [key: string]: string } = {
    // Carets
    'caret-alt-down': 'fa fa-caret-down',
    'caret-alt-right': 'fa fa-caret-right',
    'caret-alt-up': 'fa fa-caret-up',
    'caret-alt-left': 'fa fa-caret-left',

    // Grid sorting
    'sort-asc-small': 'fa-solid fa-arrow-up',
    'sort-desc-small': 'fa-solid fa-arrow-down',
    'sort-asc-sm': 'fa-solid fa-arrow-up',
    'sort-desc-sm': 'fa-solid fa-arrow-down',

    // Grid navigation
    'arrow-e': 'fa fa-caret-right',
    'arrow-w': 'fa fa-caret-left',

    // Grid/PanelBar expand/collapse
    collapse: 'fa fa-caret-down',
    expand: 'fa fa-caret-right',
    plus: 'fa fa-caret-right',
    minus: 'fa fa-caret-down',

    // PanelBar chevron expand/collapse
    'chevron-down': 'fa fa-chevron-down',
    'chevron-up': 'fa fa-chevron-up',
    'arrow-chevron-up': 'fa fa-chevron-up',
    'arrow-chevron-down': 'fa fa-chevron-down',

    // Toolbar overflow
    'more-vertical': 'fa-solid fa-ellipsis',
    'more-horizontal': 'fa-solid fa-ellipsis',

    // Search (dropdownlist filter)
    search: 'fa fa-search',

    // DateTime
    clock: 'fa fa-clock',

    // Splitter arrows
    'arrow-60-left': 'fa fa-circle-arrow-left',
    'arrow-60-right': 'fa fa-circle-arrow-right',
    'arrow-60-up': 'fa fa-circle-arrow-up',
    'arrow-60-down': 'fa fa-circle-arrow-down',

    // Misc (from icons.sass)
    tag: 'fa fa-tag',
    flask: 'fa fa-flask',
    calendar: 'fa fa-calendar',
    folder: 'far fa-folder-open',
    close: 'fa fa-times-circle',
    x: 'fa fa-times',
    'x-circle': 'fa fa-times-circle',
    warning: 'fa fa-exclamation-triangle',
  };

  public override getCustomFontIconClass(iconName: string): string {
    return this.iconDictionary[iconName] || super.getCustomFontIconClass(iconName);
  }
}
